// extracted by mini-css-extract-plugin
module.exports = {"content":"content___2nmJ2","title":"title___1zgSy","featuredAuthor":"featuredAuthor___3qRAv","dek":"dek___1-TZi"};